// eslint-disable-next-line
// @ts-nocheck
import { deepLinking } from 'startup';

export default function login() {
	return Promise.all([
		deepLinking.beforeInitializeLoginForm(),
		aras.OAuthServerDiscovery.discover(aras.getServerBaseURL())
	])
		.then(function (result) {
			const deepLinkingResult = result[0];
			if (deepLinkingResult.startItemHandled === true) {
				return;
			}
			const oauthServerConfiguration = result[1];
			const clientUrlsUtility = new window.ClientUrlsUtility(aras.getBaseURL());
			const clientBaseUrl = clientUrlsUtility.getBaseUrlWithoutSalt() + '/';
			return aras.OAuthClient.init(
				window.oauthClientId,
				clientBaseUrl,
				oauthServerConfiguration
			)
				.then(async function () {
					const navigatedFromRedirectCallbackKey =
						'OAuth:NavigatedFromRedirectCallback';
					const params = new URLSearchParams(
						location.search.substr(1, location.search.length)
					);
					const options = {
						prompt: params.get('prompt'),
						database: params.get('db'),
						authentication_type: params.get('auth'),
						state: {
							returnUrl: location.href
						}
					};

					if (options.prompt === '') {
						options.prompt = 'select_account';
					}

					if (sessionStorage[navigatedFromRedirectCallbackKey] === 'true') {
						// Deteleting prompt field to avoid cyclic navigation to login page
						// after redirection from OAuth server after authorization
						delete options.prompt;
						sessionStorage.removeItem(navigatedFromRedirectCallbackKey);
					}

					const registration = await navigator.serviceWorker?.getRegistration(
						window.location
					);
					if (registration) {
						const { active: worker } = await navigator.serviceWorker.ready;
						// worker can occasionally be null during Firefox selenium tests execution against an AICD instance.
						// This seems to be caused by a bug in Firefox service worker logic. In AICD oauth and client work
						// under different domains (urls), so probably switching domains (client -> oauth -> client) during the login
						// process can somehow "break" the service worker registration process (which occurs at the client's domain).
						// Also currently selenium tests are run against MSI Innovator only with http protocol (not https), which means
						// that the service worker feature is disabled (it's disabled by default for http), so probably this issue is not
						// specific to AICD.
						if (worker) {
							const salt = clientUrlsUtility.getSalt();
							const payload = { salt };
							worker.postMessage({ type: 'LOAD_STATIC', payload });
						}
					}

					return aras.OAuthClient.login(options);
				})
				.then(function (result) {
					if (result.status == 'logged-in') {
						return aras.login().then(function () {
							window.onSuccessfulLogin();
						});
					}
				});
		})
		.catch(function (err) {
			return aras.AlertError(err).then(function () {
				if (aras.OAuthClient.isLogged()) {
					const url = new URL(window.location.href);
					url.searchParams.delete('StartItem');
					let returnUrl = url.toString();

					if (
						err instanceof SOAPResults &&
						err.getFaultString() === 'Invalid user name.' &&
						!url.searchParams.has('prompt')
					) {
						if (returnUrl.includes('?')) {
							returnUrl += '&prompt';
						} else {
							returnUrl += '?prompt';
						}
					}

					return aras.OAuthClient.logout({
						state: {
							returnUrl: returnUrl
						}
					});
				}
			});
		});
}
